import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmPasswordValidator } from '../common/confirm-password-validator';
import { TimesheetService } from '../services/timesheet.service';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  loading = false;
  token!: string;
  setPasswordForm: FormGroup = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(),
    password_confirmation: new FormControl()
  });
  submitted = false;
  err: string = '';
  successfullySet = false;
  linkExpired = false;
  showPassword = false;
  showConfirm = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private timesheetService: TimesheetService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.queryParams['token']) {
      this.token = this.route.snapshot.queryParams['token'];
    }
    const presetEmail =
      this.route.snapshot.queryParams['email'] ||
      localStorage.getItem('email') ||
      '';
    this.setPasswordForm = this.formBuilder.group(
      {
        email: [presetEmail,
          [Validators.required, Validators.email]
        ],
        password: ['',
          [Validators.required, Validators.minLength(8)]
        ],
        password_confirmation: ['',
          [Validators.required, Validators.minLength(8), ConfirmPasswordValidator.confirmPasswordValidator(this.setPasswordForm, 'password')]
        ],
      }
    );
  }

  get rForm(): { [key: string]: AbstractControl } {
    return this.setPasswordForm.controls;
  }

  validatePasswordConfirmation() {
    this.setPasswordForm.get('password_confirmation')?.setValidators([
      Validators.required, Validators.minLength(8), ConfirmPasswordValidator.confirmPasswordValidator(this.setPasswordForm, 'password')
    ]);
  }

  /* ---- Strength rule helpers (purely informational; do not gate submit) ---- */
  private get pwd(): string { return this.rForm['password']?.value || ''; }
  get rule8(): boolean { return this.pwd.length >= 8; }
  get ruleUpper(): boolean { return /[A-Z]/.test(this.pwd); }
  get ruleNumber(): boolean { return /\d/.test(this.pwd); }
  get ruleSymbol(): boolean { return /[^A-Za-z0-9]/.test(this.pwd); }

  setPassword() {
    this.err = '';
    this.submitted = true;
    this.successfullySet = false;
    if (this.setPasswordForm.valid) {
      this.loading = true;
      const payload = { ...this.setPasswordForm.value, token: this.token };
      this.timesheetService.setPassword(payload).subscribe({
        next: () => {
          this.loading = false;
          this.successfullySet = true;
        },
        error: (err) => {
          this.loading = false;
          const msg = (err || '').toString().toLowerCase();
          if (msg.includes('expired') || msg.includes('invalid token') || msg.includes('token') && msg.includes('invalid')) {
            this.linkExpired = true;
          } else {
            this.err = err;
          }
        }
      });
    }
  }

  goToLogin() {
    this.router.navigate(['login']);
  }

  requestNewLink() {
    const ref = this.dialog.open(ForgotPasswordComponent, {
      panelClass: 'clug-dialog-panel',
      data: {},
    });
    ref.afterClosed().subscribe(result => {
      if (result?.emailSent) {
        this.router.navigate(['login']);
      }
    });
  }
}
